/**
 * F5-T6b · Admin 09 — clasificación del contrato para el feed de auditoría:
 * 5 grupos de filtro («Cinco filtros, no veinte») y 4 tipos de evento
 * (Lectura · Cambio · Sensible · Irreversible). Compartida entre la página
 * y el modal de detalle (módulo propio para no crear import circular).
 *
 * Trabaja por prefijos/sufijos sobre el action crudo: cubre también las
 * acciones que existen solo en el enum del server (ADMIN_PHI_EXPORT_AD_HOC,
 * BULK_REASSIGN_EXECUTED, TIER_THRESHOLDS_EDITED, …).
 */

export type FeedGroup = 'paciente' | 'config' | 'usuarios' | 'exports';
export type EventKind = 'lectura' | 'cambio' | 'sensible' | 'irreversible';

/** Grupo del contrato (o null → solo visible bajo «Todo»). */
export function groupOf(action: string): FeedGroup | null {
  if (action.startsWith('EXPORT_') || action.includes('PHI_EXPORT')) return 'exports';
  if (action === 'CONFIG_CHANGE' || action === 'SYSTEM_CONFIG_UPDATED' || action.startsWith('TIER_')) {
    return 'config';
  }
  if (
    action.startsWith('LOGIN') ||
    action === 'LOGOUT' ||
    action === 'AUTO_LOGOUT' ||
    action.startsWith('PASSWORD_') ||
    action.startsWith('MFA_') ||
    action === 'REFRESH_TOKEN' ||
    action.startsWith('USER_') ||
    action === 'PROFILE_UPDATED'
  ) {
    return 'usuarios';
  }
  if (
    action.startsWith('VIEW_') ||
    action.startsWith('EDIT_') ||
    action === 'START_SCREENING' ||
    action === 'SUBMIT_SCREENING' ||
    action === 'REVOKE_SUBMIT' ||
    action === 'ASSIGNMENT_ABANDONED' ||
    action.startsWith('SCREENING_') ||
    action.startsWith('HOUSEHOLD_') ||
    action.endsWith('_CLIENT_SEARCH')
  ) {
    return 'paciente';
  }
  return null;
}

/** Tipo de evento (4, cerrado): punto de color + chip que lo dice en palabras. */
export function kindOf(action: string): EventKind {
  if (action.startsWith('VIEW_') || action === 'PREVIEW_BATCH' || action.endsWith('_SEARCH')) {
    return 'lectura';
  }
  if (
    action.startsWith('EXPORT_') ||
    action.includes('PHI_EXPORT') ||
    action === 'PASSWORD_RESET' ||
    action === 'MFA_DISABLE' ||
    action === 'BULK_REASSIGN_EXECUTED'
  ) {
    return 'sensible';
  }
  if (action === 'USER_DEACTIVATE' || action.endsWith('_DELETED')) {
    return 'irreversible';
  }
  return 'cambio';
}
